import React from 'react';
import Avatar from "@mui/material/Avatar";
import {ListItemIcon, ListItemText, ThemeProvider, Typography} from "@mui/material";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import RepeatOutlinedIcon from '@mui/icons-material/RepeatOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import {Link, useNavigate} from "react-router-dom";
import JumboDdPopover from "@jumbo/components/JumboDdPopover";
import Div from "@jumbo/shared/Div";
import useJumboTheme from "@jumbo/hooks/useJumboTheme";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";


const AuthUserDropdown = () => {
    const navigate = useNavigate();
    const {theme} = useJumboTheme();
    const {setAuthToken} = useJumboAuth();
    const getNameFromLocalStorage = localStorage.getItem("storedUsername")
    const getEmailFromLocalStorage = localStorage.getItem("storedUserEmail")
    const getImageFromLocalStorage = localStorage.getItem("storedUserImage");
    const getStoredPermissionsFromLocalStorage = JSON.parse(localStorage.getItem("storedPermissions"))
    const getUserIdFromLocalStorage = localStorage.getItem("storedUserId");

    const [anchorEl, setAnchorEl] = React.useState(null);

    const onLogout = () => {
        setAuthToken(null);
        navigate("/login");
    };

    const handleEditClick = () => {
        // Recolhe o dropdown
        setAnchorEl(null);
    
        // Redireciona para a página de edição de perfil
        window.scrollTo({ top: 0, behavior: 'smooth' })
        navigate(`/app/editar-usuario/${getUserIdFromLocalStorage}`);
    };

    const uniqueNames = [...new Set(getStoredPermissionsFromLocalStorage?.map(p => p.perfil.nome))];
    
    return (
        <ThemeProvider theme={theme}>
            <JumboDdPopover
                triggerButton={
                    <Avatar
                        src={getImageFromLocalStorage ?`${process.env.REACT_APP_API_KEY}/images/${getImageFromLocalStorage}` : '#'}
                        sizes={"small"}
                        sx={{boxShadow: 25, cursor: 'pointer'}}
                    />
                }
                setAnchorEl={setAnchorEl}
                anchorEl={anchorEl}
            >
                <Div sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    //width: '220px',
                    p: theme => theme.spacing(2.5),
                }}>
                    <Avatar src={getImageFromLocalStorage ?`${process.env.REACT_APP_API_KEY}/images/${getImageFromLocalStorage}` : '#'} alt={getNameFromLocalStorage} sx={{width: 60, height: 60, mb: 2}}/>
                    <Typography sx={{textAlign: 'center'}} variant={"h5"}>{getNameFromLocalStorage}</Typography>
                    <Typography variant={"body1"} color="text.secondary">{getEmailFromLocalStorage}</Typography>
                    {uniqueNames?.map((name, index) => (
                        <Typography 
                            key={index} 
                            variant={"body1"} 
                            color="text.secondary"
                            sx={{textAlign: 'center'}}
                        >{name}
                        </Typography>
                    ))}
                </Div>
                <Divider/>
                <nav>
                    <List disablePadding sx={{pb: 1}}>
                        <ListItemButton onClick={handleEditClick}>
                            <ListItemIcon sx={{minWidth: 36}}>
                                <EditOutlinedIcon/>
                            </ListItemIcon>
                            {/* <Link 
                                to={`app/editar-aluno/${getUserIdFromLocalStorage}`}
                                style={{textDecoration: 'none', color: '#475259'}} 
                            >
                                Editar Perfil
                            </Link> */}
                            <ListItemText primary="Editar Usuário" sx={{my: 0}}/>
                        </ListItemButton>
                        
                        <ListItemButton onClick={onLogout}>
                            <ListItemIcon sx={{minWidth: 36}}>
                                <LogoutIcon/>
                            </ListItemIcon>
                            <ListItemText primary="Sair" sx={{my: 0}}/>
                        </ListItemButton>
                    </List>
                </nav>
            </JumboDdPopover>
        </ThemeProvider>
    );
};

export default AuthUserDropdown;
